import {currentLanguage} from './config';

/**
 * LOCAL TRANSLATIONS
 */
export default function getLabels() {
    let frLabels = {
		days: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
		months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
		closed: 'Fermé',
		open: 'Ouvert',
		noMarques: 'Pas de marques disponibles.',
		finalPriceNote: 'Le montant final peut varier en fonction du véhicule, des pièces nécessaires et autres.',
		currency: '€',
		emptyField: 'Ce champ ne peut pas être vide!',
		invalidEmail: "L'e-mail n'est pas valide!",
		dropOffMessage: 'Le client déposera la voiture à : ',
		noDescription: 'Aucune description.',
		contact: "En cas d'urgence",
		directly: 'contactez directement',
		notFoundChassisNumber: 'Numéro de châssis non trouvé. Veuillez réessayer.',
		emptySlot: 'Indisponible',
		generalErrorMessages: 'Une erreur s’est produite, veuillez nous excuser pour ce désagrément.',
		tax: 'TVA incl.',
		emptyTimeSlot: 'Malheureusement, ce créneau a été réservé par un autre client. Veuillez réserver une autre plage horaire.',
	};
    let nlLabels = {
		days: ['Lundi NL', 'Mardi NL', 'Mercredi NL', 'Jeudi NL', 'Vendredi NL', 'Samedi NL', 'Dimanche NL'],
		months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
		closed: 'Gesloten',
		open: 'Open',
		noMarques: 'Geen beschikbare merken.',
		finalPriceNote: 'Le montant final peut varier en fonction du véhicule, des pièces nécessaires et autres. NL',
		currency: '€',
		emptyField: 'TDit veld mag niet leeg zijn!',
		invalidEmail: 'E-mail is niet geldig!',
		dropOffMessage: 'Klant zal de auto afleveren op: ',
		noDescription: 'Geen beschrijving.',
		contact: 'In geval van nood',
		directly: 'neem contact op met',
		notFoundChassisNumber: 'Chassisnummer niet gevonden. Probeer het opnieuw.',
		emptySlot: 'Onbeschikbaar',
		generalErrorMessages: 'Er is een fout opgetreden, excuses voor het ongemak.',
		tax: 'BTW incl.',
		emptyTimeSlot: 'Helaas, dit uur is inmiddels ingeboekt door een andere klant. Gelieve een ander slot te reserveren.',
	};
    let labels;

    /**
     * Check which language is selected and based on that assing to global @var labels variable.
     */
    if (currentLanguage === 'fr') {
        labels = frLabels;
    } else if (currentLanguage === 'nl') {
        labels = nlLabels;
    }

    return labels;
}
